// Mirror of the backend OrderSubmission.PatientNotificationOutcome enum (display-only).
export const PATIENT_NOTIFICATION_OUTCOME = Object.freeze({
  APPROVED: "APPROVED",
  APPROVED_OR_DENIED: "APPROVED_OR_DENIED",
});

export const DEFAULT_PATIENT_NOTIFICATION_OUTCOME = PATIENT_NOTIFICATION_OUTCOME.APPROVED_OR_DENIED;

export const PATIENT_NOTIFICATION_OUTCOME_OPTIONS = Object.freeze([
  { value: PATIENT_NOTIFICATION_OUTCOME.APPROVED, label: "Approved" },
  { value: PATIENT_NOTIFICATION_OUTCOME.APPROVED_OR_DENIED, label: "Approved or denied" },
]);
